webpackJsonp([1],[
/* 0 */,
/* 1 */
/*!********************************!*\
  !*** ./example/sharedState.js ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eases__ = __webpack_require__(/*! eases */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_eases__);

var easings = Object.keys(__WEBPACK_IMPORTED_MODULE_0_eases___default.a).map(function (ease) {
  return {
    label: ease,
    value: ease
  };
});

/* harmony default export */ __webpack_exports__["a"] = ({
  pointDown: true,
  thickness: 8,
  duration: 300,
  roundEdges: true,
  angle: 40,
  easings: easings,
  selectedEasing: "linear",
  color: "#ffffff",
  fontSize: 80
});

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/*!********************************!*\
  !*** multi ./example/index.js ***!
  \********************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /Users/irkopa/Code/npm/vue-chevron/example/index.js */6);


/***/ }),
/* 6 */
/*!**************************!*\
  !*** ./example/index.js ***!
  \**************************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(/*! ./App.vue */ 11);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/*!*************************!*\
  !*** ./example/App.vue ***!
  \*************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_irkopa_Code_npm_vue_chevron_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/irkopa/Code/npm/vue-chevron/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d1745e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-57d1745e","hasScoped":false,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 64);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-57d1745e","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 12)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_irkopa_Code_npm_vue_chevron_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d1745e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57d1745e","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./example/App.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/*!***********************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/irkopa/Code/npm/vue-chevron/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./example/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sharedState__ = __webpack_require__(/*! ./sharedState */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CodePreview__ = __webpack_require__(/*! ./CodePreview */ 44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Preview__ = __webpack_require__(/*! ./Preview */ 51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Props__ = __webpack_require__(/*! ./Props */ 56);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    CodePreview: __WEBPACK_IMPORTED_MODULE_1__CodePreview__["a" /* default */],
    Preview: __WEBPACK_IMPORTED_MODULE_2__Preview__["a" /* default */],
    Props: __WEBPACK_IMPORTED_MODULE_3__Props__["a" /* default */]
  },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_0__sharedState__["a" /* default */]
    };
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/*!*********************************!*\
  !*** ./example/CodePreview.vue ***!
  \*********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_irkopa_Code_npm_vue_chevron_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_CodePreview_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/irkopa/Code/npm/vue-chevron/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./CodePreview.vue */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd3618b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodePreview_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-cd3618b2","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./CodePreview.vue */ 50);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-cd3618b2","scoped":true,"hasInlineConfig":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./CodePreview.vue */ 45)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cd3618b2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_irkopa_Code_npm_vue_chevron_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_CodePreview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd3618b2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CodePreview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cd3618b2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./example/CodePreview.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/irkopa/Code/npm/vue-chevron/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./example/CodePreview.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs__ = __webpack_require__(/*! prismjs */ 47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prism_themes_themes_prism_atom_dark_css__ = __webpack_require__(/*! prism-themes/themes/prism-atom-dark.css */ 48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prism_themes_themes_prism_atom_dark_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prism_themes_themes_prism_atom_dark_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_prism_component__ = __webpack_require__(/*! vue-prism-component */ 49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_prism_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_prism_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_eases__ = __webpack_require__(/*! eases */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_eases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_eases__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sharedState__ = __webpack_require__(/*! ./sharedState */ 1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CodePreview",
  components: {
    Prism: __WEBPACK_IMPORTED_MODULE_2_vue_prism_component___default.a
  },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_4__sharedState__["a" /* default */]
    };
  },

  computed: {
    easing: function easing() {
      return __WEBPACK_IMPORTED_MODULE_3_eases___default.a[this.sharedState.selectedEasing];
    }
  }
});

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/*!*********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cd3618b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/CodePreview.vue ***!
  \*********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"code box"},[_c('div',{staticClass:"m-b"},[_c('h2',[_vm._v("\n      Install\n    ")]),_vm._v(" "),_c('prism',{attrs:{"language":"html"}},[_vm._v("\nnpm install vue-chevron --save\n    ")])],1),_vm._v(" "),_c('h2',[_vm._v("Code example")]),_vm._v(" "),_c('div',{staticClass:"code__preview"},[_c('prism',{attrs:{"language":"html"}},[_vm._v("\n<template>\n  <div class=\"example\" @click=\"toggle\">\n    <vue-chevron\n      :point-down=\"pointDown\"\n      :duration=\"duration\"\n      :thickness=\"thickness\"\n      :angle=\"angle\"\n      :round-edges=\"roundEdges\"\n    />\n  </div>\n</template>\n\n<script>\nimport VueChevron from 'vue-chevron';\n\nexport default {\n  name: 'App',\n  components: {\n    VueChevron\n  },\n  data() {\n    return {\n      pointDown: "+_vm._s(_vm.sharedState.pointDown)+",\n      thickness: "+_vm._s(_vm.sharedState.thickness)+",\n      duration: "+_vm._s(_vm.sharedState.duration)+",\n      angle: "+_vm._s(_vm.sharedState.angle)+",\n      roundEdges: "+_vm._s(_vm.sharedState.roundEdges)+",\n      easing: "+_vm._s(_vm.easing)+"\n    };\n  },\n  methods: {\n    toggle() {\n      this.pointDown = !this.pointDown;\n    }\n  }\n}\n</script>\n\n<style>\n.example {\n  color: "+_vm._s(_vm.sharedState.color)+";\n  font-size: "+_vm._s(_vm.sharedState.fontSize)+"px;\n}\n</style>\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 51 */
/*!*****************************!*\
  !*** ./example/Preview.vue ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_irkopa_Code_npm_vue_chevron_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/irkopa/Code/npm/vue-chevron/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Preview.vue */ 53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69afe83a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-69afe83a","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Preview.vue */ 55);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-69afe83a","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Preview.vue */ 52)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-69afe83a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_irkopa_Code_npm_vue_chevron_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Preview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69afe83a_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Preview_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69afe83a","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./example/Preview.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/*!***************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/irkopa/Code/npm/vue-chevron/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./example/Preview.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eases__ = __webpack_require__(/*! eases */ 3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_eases___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_eases__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sharedState__ = __webpack_require__(/*! ./sharedState */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src__ = __webpack_require__(/*! ../src */ 54);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Preview",
  components: {
    VueChevron: __WEBPACK_IMPORTED_MODULE_2__src__["a" /* default */]
  },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_1__sharedState__["a" /* default */]
    };
  },

  methods: {
    toggle: function toggle() {
      this.sharedState.pointDown = !this.sharedState.pointDown;
    }
  },
  computed: {
    easing: function easing() {
      return __WEBPACK_IMPORTED_MODULE_0_eases___default.a[this.sharedState.selectedEasing];
    }
  }
});

/***/ }),
/* 54 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var animationId = void 0;
var lastTime = null;

function linear(t) {
  return t;
}

function animate(duration, component) {
  lastTime = component.progress <= 1 ? performance.now() : lastTime;
  var animation = function animation(t) {
    var progress = (t - lastTime) / duration;
    if (progress >= 1) {
      window.cancelAnimationFrame(animationId);
      component.clickProgress = 1;
      component.progress = 1;
      return;
    }
    component.progress = component.easing(progress);
    animationId = window.requestAnimationFrame(animation);
  };
  animationId = window.requestAnimationFrame(animation);
}

function calculatePosition(pointDown, progress, lastClickProgress, height, viewBoxCenterY) {
  var progressWithClick = lastClickProgress === 1 ? progress : progress + (1 - lastClickProgress);

  if (progressWithClick >= 1) {
    progressWithClick = 1;
  }

  var topY = viewBoxCenterY + height / 2 - progressWithClick * height;
  var bottomY = viewBoxCenterY - height / 2 + progressWithClick * height;

  return pointDown ? topY : bottomY;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "VueChevron",
  props: {
    pointDown: {
      type: Boolean,
      default: true
    },
    duration: {
      type: Number,
      default: 500
    },
    thickness: {
      type: Number,
      default: 4
    },
    angle: {
      type: Number,
      default: 40
    },
    roundEdges: {
      type: Boolean,
      default: true
    },
    easing: {
      type: Function,
      default: linear
    }
  },
  data: function data() {
    return {
      progress: 1,
      clickProgress: 1,
      reverse: false,
      lineLength: 30
    };
  },

  computed: {
    path: function path() {
      var progress = this.progress;
      var _triangleSideLengths = this.triangleSideLengths,
          width = _triangleSideLengths.width,
          height = _triangleSideLengths.height;
      var _viewBoxCenter = this.viewBoxCenter,
          x = _viewBoxCenter.x,
          y = _viewBoxCenter.y;

      var clickProgress = this.clickProgress;

      var sidesY = calculatePosition(this.pointDown, progress, clickProgress, height, y);
      var centerY = calculatePosition(!this.pointDown, progress, clickProgress, height, y);
      return "M" + (x - width) + "," + sidesY + ", " + x + "," + centerY + " " + (x + width) + "," + sidesY;
    },
    triangleSideLengths: function triangleSideLengths() {
      var height = this.lineLength * Math.sin(this.angle * (Math.PI / 180));
      var width = this.lineLength * Math.cos(this.angle * (Math.PI / 180));
      return {
        width: width,
        height: height
      };
    },
    viewBoxCenter: function viewBoxCenter() {
      var _viewBoxSize = this.viewBoxSize,
          width = _viewBoxSize.width,
          height = _viewBoxSize.height;

      return { x: width / 2, y: height / 2 };
    },
    viewBoxSize: function viewBoxSize() {
      var lineLength = this.lineLength;
      var thickness = this.thickness;

      var width = Math.ceil(lineLength * 2 + thickness * 2);
      var height = Math.ceil(lineLength * 2 * Math.sin(this.angle * (Math.PI / 180)) + thickness * 2);
      return { width: width, height: height };
    }
  },
  watch: {
    pointDown: function pointDown() {
      this.clickProgress = this.progress;
      this.progress = 0;
      window.cancelAnimationFrame(animationId);
      animate(this.duration, this);
    }
  },
  render: function render(h) {
    var lineCapAndJoin = this.roundEdges ? "round" : "square";
    var _viewBoxSize2 = this.viewBoxSize,
        width = _viewBoxSize2.width,
        height = _viewBoxSize2.height;


    return h("svg", {
      attrs: {
        height: 32,
        width: 32,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 " + width + " " + height
      }
    }, [h("title", "vue-chevron"), h("path", {
      attrs: {
        d: this.path,
        fill: "none",
        "stroke-linecap": lineCapAndJoin,
        "stroke-width": this.thickness,
        "stroke-linejoin": lineCapAndJoin,
        stroke: "currentColor"
      }
    })]);
  }
});

/***/ }),
/* 55 */
/*!*****************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69afe83a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/Preview.vue ***!
  \*****************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"preview"},[_c('div',{staticClass:"row center-xs"},[_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-2"},[_c('div',{staticClass:"align-center"},[_c('label',[_vm._v("Color")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.sharedState.color),expression:"sharedState.color"}],attrs:{"type":"color"},domProps:{"value":(_vm.sharedState.color)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sharedState, "color", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-3 col-lg-2 preview__col"},[_c('div',{staticClass:"align-center preview__wrap"},[_c('div',{staticClass:"preview__svg",style:(("color: " + (_vm.sharedState.color) + "; font-size: " + (_vm.sharedState.fontSize) + "px")),on:{"click":_vm.toggle}},[_c('vue-chevron',{attrs:{"point-down":_vm.sharedState.pointDown,"duration":_vm.sharedState.duration,"thickness":_vm.sharedState.thickness,"angle":_vm.sharedState.angle,"round-edges":_vm.sharedState.roundEdges,"easing":_vm.easing}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-4 col-md-2"},[_c('div',{staticClass:"align-center"},[_c('label',[_vm._v("Font size ("+_vm._s(_vm.sharedState.fontSize)+"px)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.sharedState.fontSize),expression:"sharedState.fontSize",modifiers:{"number":true}}],attrs:{"type":"range","min":"10","max":"150","step":"1"},domProps:{"value":(_vm.sharedState.fontSize)},on:{"__r":function($event){_vm.$set(_vm.sharedState, "fontSize", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 56 */
/*!***************************!*\
  !*** ./example/Props.vue ***!
  \***************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_irkopa_Code_npm_vue_chevron_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Props_vue__ = __webpack_require__(/*! !babel-loader?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/irkopa/Code/npm/vue-chevron/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!../node_modules/vue-loader/lib/selector?type=script&index=0!./Props.vue */ 58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ac82d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Props_vue__ = __webpack_require__(/*! !../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-54ac82d2","hasScoped":true,"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector?type=template&index=0!./Props.vue */ 63);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-54ac82d2","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../node_modules/vue-loader/lib/selector?type=styles&index=0!./Props.vue */ 57)
}
var normalizeComponent = __webpack_require__(/*! ../node_modules/vue-loader/lib/component-normalizer */ 0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-54ac82d2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_cacheDirectory_true_babelrc_false_presets_Users_irkopa_Code_npm_vue_chevron_node_modules_babel_preset_poi_index_js_jsx_vue_node_modules_vue_loader_lib_selector_type_script_index_0_Props_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54ac82d2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Props_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54ac82d2","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./example/Props.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/*!*************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"cacheDirectory":true,"babelrc":false,"presets":[["/Users/irkopa/Code/npm/vue-chevron/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./example/Props.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_switches__ = __webpack_require__(/*! vue-switches */ 59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sharedState__ = __webpack_require__(/*! ./sharedState */ 1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Preview",
  components: {
    Switches: __WEBPACK_IMPORTED_MODULE_0_vue_switches__["a" /* default */]
  },
  data: function data() {
    return {
      sharedState: __WEBPACK_IMPORTED_MODULE_1__sharedState__["a" /* default */]
    };
  }
});

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/*!***************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54ac82d2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/Props.vue ***!
  \***************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"props box"},[_c('h2',[_vm._v("Props")]),_vm._v(" "),_c('form',[_c('table',[_vm._m(0),_vm._v(" "),_c('tr',[_c('td',[_c('label',[_vm._v("Duration ("+_vm._s(_vm.sharedState.duration)+"ms)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.sharedState.duration),expression:"sharedState.duration",modifiers:{"number":true}}],attrs:{"type":"range","min":"200","max":"2000","step":"100"},domProps:{"value":(_vm.sharedState.duration)},on:{"__r":function($event){_vm.$set(_vm.sharedState, "duration", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("300")])]),_vm._v(" "),_c('tr',[_c('td',[_c('label',[_vm._v("Thickness ("+_vm._s(_vm.sharedState.thickness)+")")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.sharedState.thickness),expression:"sharedState.thickness",modifiers:{"number":true}}],attrs:{"type":"range","min":"1","max":"50","step":"1"},domProps:{"value":(_vm.sharedState.thickness)},on:{"__r":function($event){_vm.$set(_vm.sharedState, "thickness", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("8")])]),_vm._v(" "),_c('tr',[_c('td',[_c('label',[_vm._v("Angle ("+_vm._s(_vm.sharedState.angle)+"°)")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.sharedState.angle),expression:"sharedState.angle",modifiers:{"number":true}}],attrs:{"type":"range","min":"10","max":"60","step":"1"},domProps:{"value":(_vm.sharedState.angle)},on:{"__r":function($event){_vm.$set(_vm.sharedState, "angle", _vm._n($event.target.value))},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('td',[_vm._v("Number")]),_vm._v(" "),_c('td',[_vm._v("40")])]),_vm._v(" "),_c('tr',[_c('td',[_c('label',[_vm._v("Round edges")]),_vm._v(" "),_c('switches',{attrs:{"theme":"bulma","color":"primary"},model:{value:(_vm.sharedState.roundEdges),callback:function ($$v) {_vm.$set(_vm.sharedState, "roundEdges", $$v)},expression:"sharedState.roundEdges"}})],1),_vm._v(" "),_c('td',[_vm._v("Boolean")]),_vm._v(" "),_c('td',[_vm._v("true")])]),_vm._v(" "),_c('tr',[_c('td',[_c('label',[_vm._v("Easings")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sharedState.selectedEasing),expression:"sharedState.selectedEasing"}],on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.sharedState, "selectedEasing", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.sharedState.easings),function(ease,index){return _c('option',{key:index,domProps:{"value":ease.value}},[_vm._v("\n              "+_vm._s(ease.label)+"\n            ")])})),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('td',[_vm._v("Function")]),_vm._v(" "),_c('td',[_vm._v("linear")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("Prop")]),_vm._v(" "),_c('th',[_vm._v("Type")]),_vm._v(" "),_c('th',[_vm._v("Default value")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('small',[_vm._v("These are here only for the demo. Easings are not included to keep the library size minimum. Pass in your own easing functions to get the desired effect.")]),_vm._v(" "),_c('p',[_vm._v("\n              Check eg. "),_c('a',{attrs:{"href":"https://github.com/mattdesl/eases","target":"_blank"}},[_vm._v("Easing functions")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 64 */
/*!**************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57d1745e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./example/App.vue ***!
  \**************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"bg-pattern"}),_vm._v(" "),_c('div',{staticClass:"wrap container-fluid"},[_c('h1',[_vm._v("Vue Chevron")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"btn-wrap m-b"},[_c('a',{staticClass:"btn",attrs:{"href":"https://github.com/ispal/vue-chevron","target":"_blank","rel":"noopener"}},[_c('svg',{staticClass:"icon icon-github",attrs:{"viewBox":"0 0 24 28"}},[_c('title',[_vm._v("github")]),_vm._v(" "),_c('path',{attrs:{"d":"M12 2c6.625 0 12 5.375 12 12 0 5.297-3.437 9.797-8.203 11.391-0.609 0.109-0.828-0.266-0.828-0.578 0-0.391 0.016-1.687 0.016-3.297 0-1.125-0.375-1.844-0.812-2.219 2.672-0.297 5.484-1.313 5.484-5.922 0-1.313-0.469-2.375-1.234-3.219 0.125-0.313 0.531-1.531-0.125-3.187-1-0.313-3.297 1.234-3.297 1.234-0.953-0.266-1.984-0.406-3-0.406s-2.047 0.141-3 0.406c0 0-2.297-1.547-3.297-1.234-0.656 1.656-0.25 2.875-0.125 3.187-0.766 0.844-1.234 1.906-1.234 3.219 0 4.594 2.797 5.625 5.469 5.922-0.344 0.313-0.656 0.844-0.766 1.609-0.688 0.313-2.438 0.844-3.484-1-0.656-1.141-1.844-1.234-1.844-1.234-1.172-0.016-0.078 0.734-0.078 0.734 0.781 0.359 1.328 1.75 1.328 1.75 0.703 2.141 4.047 1.422 4.047 1.422 0 1 0.016 1.937 0.016 2.234 0 0.313-0.219 0.688-0.828 0.578-4.766-1.594-8.203-6.094-8.203-11.391 0-6.625 5.375-12 12-12zM4.547 19.234c0.031-0.063-0.016-0.141-0.109-0.187-0.094-0.031-0.172-0.016-0.203 0.031-0.031 0.063 0.016 0.141 0.109 0.187 0.078 0.047 0.172 0.031 0.203-0.031zM5.031 19.766c0.063-0.047 0.047-0.156-0.031-0.25-0.078-0.078-0.187-0.109-0.25-0.047-0.063 0.047-0.047 0.156 0.031 0.25 0.078 0.078 0.187 0.109 0.25 0.047zM5.5 20.469c0.078-0.063 0.078-0.187 0-0.297-0.063-0.109-0.187-0.156-0.266-0.094-0.078 0.047-0.078 0.172 0 0.281s0.203 0.156 0.266 0.109zM6.156 21.125c0.063-0.063 0.031-0.203-0.063-0.297-0.109-0.109-0.25-0.125-0.313-0.047-0.078 0.063-0.047 0.203 0.063 0.297 0.109 0.109 0.25 0.125 0.313 0.047zM7.047 21.516c0.031-0.094-0.063-0.203-0.203-0.25-0.125-0.031-0.266 0.016-0.297 0.109s0.063 0.203 0.203 0.234c0.125 0.047 0.266 0 0.297-0.094zM8.031 21.594c0-0.109-0.125-0.187-0.266-0.172-0.141 0-0.25 0.078-0.25 0.172 0 0.109 0.109 0.187 0.266 0.172 0.141 0 0.25-0.078 0.25-0.172zM8.937 21.438c-0.016-0.094-0.141-0.156-0.281-0.141-0.141 0.031-0.234 0.125-0.219 0.234 0.016 0.094 0.141 0.156 0.281 0.125s0.234-0.125 0.219-0.219z"}})]),_vm._v(" "),_c('span',[_vm._v("\n          View on Github\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"demo"},[_c('preview')],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-6"},[_c('code-preview')],1),_vm._v(" "),_c('div',{staticClass:"col-xs-12 col-sm-6 first-xs last-sm "},[_c('props')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row center-xs badges"},[_c('div',{staticClass:"col-xs-12 col-sm-8"},[_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":"https://img.shields.io/npm/v/vue-chevron.svg?style=flat","alt":"Version","data-canonical-src":"https://img.shields.io/npm/v/vue-chevron.svg?style=flat"}}),_vm._v(" "),_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":"https://img.shields.io/npm/dm/vue-chevron.svg","alt":"npm downloads","data-canonical-src":"https://img.shields.io/npm/dm/vue-chevron.svg"}}),_vm._v(" "),_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":"https://img.shields.io/david/ispal/vue-chevron.svg?style=flat","alt":"No Dependencies","data-canonical-src":"https://img.shields.io/david/ispal/vue-chevron.svg?style=flat"}}),_vm._v(" "),_c('img',{staticStyle:{"max-width":"100%"},attrs:{"src":"https://img.shields.io/npm/l/vue-chevron.svg?style=flat","alt":"License","data-canonical-src":"https://img.shields.io/npm/l/vue-chevron.svg?style=flat"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[5]);


// WEBPACK FOOTER //
// client.1831c4ad.js